<template>
  <div style="height:100%">
    <el-row class="title-bar mr-t10" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h4">예외 알람 이력</div>
      </div>
      <div class="vertical-center-box">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="isLoading" ref="table" border header-align="center" :data="tableData" :columns="tableColumns"
    :show-custom-header="true" :show-search-tool="showSearchTool" :pagination="true" :fit-height="true" @condition-change="loadData" remote
    style="height: calc(100vh - 502px);border-bottom: 1px solid #EBEEF5;" />
  </div>
</template>

<script>
import { isNil, isEmpty } from 'lodash';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import EventHistAPI from '@/api/event/event-hist';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WRootCauseAlarmTable',
  props: {
    eventHistData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    rootObjId() {
      if (!isNil(this.eventHistData)) {
        return this.eventHistData.objId;
      }
      return 0;
    },
    rootEventSeqNumber() {
      if (!isNil(this.eventHistData)) {
        return this.eventHistData.seqNumber;
      }
      return 0;
    },
  },
  data() {
    return {
      showSearchTool: false,
      isLoading: false,
      total: 0,
      tableData: [],
      tableColumns: [
        {
          prop: 'alarmtypeName',
          label: '전송구분',
          width: 110,
          headerAlign: 'center',
          remoteProp: 'alarmtypeId',
          filters: [
            {
              text: '이메일',
              value: 'EMAIL',
            },
            {
              text: '메신저',
              value: 'MESSENGER',
            },
            {
              text: '문자',
              value: 'SMS',
            },
          ],
          formatter: defaultFormatter,
        },
        {
          prop: 'senderInfo',
          label: '전송자',
          width: 130,
          headerAlign: 'center',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'receiverInfo',
          label: '수신자',
          width: 130,
          headerAlign: 'center',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'alarmMessage',
          label: '알람내용',
          searchable: true,
          headerAlign: 'center',
          formatter: defaultFormatter,
        },
        {
          prop: 'checkDatetime',
          label: '전송시각',
          width: 130,
          headerAlign: 'center',
          // searchType: 'date',
          // searchable: true,
          formatter: this.getDateFormatter,
        },
      ],
    };
  },
  watch: {
    eventHistData: {
      handler(to) {
        if (!isEmpty(to)) {
          this.$nextTick(() => {
            this.loadData();
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      this.isLoading = true;
      const tableParams = this.$refs.table.getParameter();
      const params = {
        ...tableParams,
        rootEventSeqNumber: this.rootEventSeqNumber,
        rootObjId: this.rootObjId,
      };
      EventHistAPI.getRootCauseAlarmExceptList(params).then((response) => {
        const result = response.data;
        if (result.success) {
          this.tableData = result.data;
          this.total = result.total;
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/event-hist/popup/RootCauseAnalysisPopup/components/RootCauseAlarmTable.vue